import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AnimatedDashboard } from '../../../components/animation/AnimatedDashboard';
import { H3, P3, P2, P1, CaptionText } from '../../../styles/FontStyles';
import {
  Flexed,
  SectionSeparator,
  SlideWrapper
} from '../../../styles/GlobalComponents';
import { colors } from '../../../styles/GlobalStyles';
import { getEntryPackages } from '../Marketplace.actions';
import {
  formatUSDNoDecimals,
  dateDifferenceInDaysFromToday
} from '../../../helpers/helperFunctions';
import { EntryPackagesGrid, GridItem } from './EntryPackage.styled';
import { Button } from '../../../components/common/Button/Button';
import Spinner from '../../../components/common/Spinner';
import { Icon } from '../../../styles/Icons';
import { getUserTickets } from '../../../slices/auth-slice';
import { PurchasePackageAndCombo } from '../PurchasePackageAndCombo/PurchasePackageAndCombo';
import { DASHBOARD } from '../../../routes/routes';
import { getLicenses } from '../../Settings/Settings.actions';
import { Desktop, Mobile } from '../../../App';
import { PurchaseSteps } from '../Maeketplace.types';

import { purchasePackage } from '../Marketplace.actions';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import { Link } from 'react-router-dom';

export const EntryPackages = () => {
  const dispatch = useDispatch();
  const { loading, hubs } = useSelector((state) => state.marketplace);
  const { userInfo } = useSelector((state) => state.auth);
  const [step, setStep] = useState(PurchaseSteps.PAY_TETHER);
  const [selectedLicence, setSelectedLicence] = useState();
  const [selectedHub, setSelectedHub] = useState(hubs?.[0] || null);
  const [modal, setModal] = useState(false);

  const licenceDate = dateDifferenceInDaysFromToday(
    userInfo?.user?.currentVirtualOfficeLicence?.dateEnd
  );

  useEffect(() => {
    dispatch(getLicenses());
    dispatch(getEntryPackages());
    dispatch(getUserTickets());
  }, [dispatch]);

  const handleSelectPackage = (hub) => {
    setModal(true);
    setSelectedHub(hub);
    setSelectedLicence(null);

    if (
      licenceDate <= 30 &&
      licenceDate > 0 &&
      !userInfo?.user?.currentVirtualOfficeLicence?.licence?.licenceId
    ) {
      setStep(PurchaseSteps.INITIAL);
      setSelectedLicence();
    } else {
      dispatch(
        purchasePackage({
          packageId: hub.id,
          licenceId: null,
          currency: 'usdt',
          networkType: 1,
          handleSuccess: () => setStep(PurchaseSteps.SUCCESS)
        })
      );
    }
  };

  if (loading) return <Spinner fullScreen={true} />;

  const returnFractions = (id) => {
    switch (id) {
      case 350:
        return 4;
      case 351:
        return 8;
      case 352:
        return 20;
      case 355:
        return 2;
      default:
        break;
    }
  };

  const PackageItem = ({ hub, index }) => {
    return (
      <GridItem
        image={hub?.imageUrl}
        key={index}
        selected={selectedHub?.id === hub?.id}>
        <div>
          <Flexed column center>
            <H3 color={colors.neutral0} mb='100' mt='20'></H3>
          </Flexed>

          <Flexed height='200px'>
            <div>
              {hub?.name !== 'Starter' && (
                <>
                  <Flexed center between gap='10px' mb='12' key={index}>
                    <Flexed center gap='5px'>
                      <Icon color={colors.lightGreen}>
                        <svg
                          width='16'
                          height='15'
                          viewBox='0 0 16 15'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'>
                          <path
                            d='M8.07812 1.40625C4.71807 1.40625 1.98438 4.13994 1.98438 7.5C1.98438 10.8601 4.71807 13.5937 8.07812 13.5937C11.4382 13.5937 14.1719 10.8601 14.1719 7.5C14.1719 4.13994 11.4382 1.40625 8.07812 1.40625ZM11.2495 5.45771L7.31201 10.1452C7.26882 10.1967 7.21508 10.2382 7.15442 10.2671C7.09376 10.2959 7.02761 10.3114 6.96045 10.3125H6.95254C6.88684 10.3125 6.82187 10.2986 6.76186 10.2719C6.70185 10.2451 6.64814 10.2061 6.6042 10.1572L4.9167 8.28223C4.87384 8.23677 4.8405 8.18321 4.81864 8.12468C4.79678 8.06616 4.78684 8.00386 4.78941 7.94144C4.79197 7.87902 4.80698 7.81774 4.83356 7.7612C4.86015 7.70467 4.89776 7.65402 4.9442 7.61223C4.99064 7.57044 5.04496 7.53835 5.10398 7.51786C5.16299 7.49736 5.22551 7.48887 5.28785 7.49288C5.35019 7.49689 5.41111 7.51332 5.46701 7.54121C5.52291 7.5691 5.57268 7.60788 5.61338 7.65527L6.94023 9.12949L10.5317 4.85479C10.6123 4.76164 10.7263 4.70395 10.849 4.69416C10.9718 4.68438 11.0935 4.7233 11.1878 4.80251C11.2821 4.88172 11.3414 4.99485 11.353 5.11745C11.3645 5.24006 11.3273 5.36229 11.2495 5.45771Z'
                            fill='#53C0F2'
                          />
                        </svg>
                      </Icon>

                      <CaptionText left color={colors.neutral0}>
                        Minara -{' '}
                        {formatUSDNoDecimals(hub?.details?.minara?.credits)}{' '}
                        Credits
                      </CaptionText>
                    </Flexed>
                  </Flexed>
                  <Flexed center between gap='10px' mb='12' key={index}>
                    <Flexed center gap='5px'>
                      <Icon color={colors.lightGreen}>
                        <svg
                          width='16'
                          height='15'
                          viewBox='0 0 16 15'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'>
                          <path
                            d='M8.07812 1.40625C4.71807 1.40625 1.98438 4.13994 1.98438 7.5C1.98438 10.8601 4.71807 13.5937 8.07812 13.5937C11.4382 13.5937 14.1719 10.8601 14.1719 7.5C14.1719 4.13994 11.4382 1.40625 8.07812 1.40625ZM11.2495 5.45771L7.31201 10.1452C7.26882 10.1967 7.21508 10.2382 7.15442 10.2671C7.09376 10.2959 7.02761 10.3114 6.96045 10.3125H6.95254C6.88684 10.3125 6.82187 10.2986 6.76186 10.2719C6.70185 10.2451 6.64814 10.2061 6.6042 10.1572L4.9167 8.28223C4.87384 8.23677 4.8405 8.18321 4.81864 8.12468C4.79678 8.06616 4.78684 8.00386 4.78941 7.94144C4.79197 7.87902 4.80698 7.81774 4.83356 7.7612C4.86015 7.70467 4.89776 7.65402 4.9442 7.61223C4.99064 7.57044 5.04496 7.53835 5.10398 7.51786C5.16299 7.49736 5.22551 7.48887 5.28785 7.49288C5.35019 7.49689 5.41111 7.51332 5.46701 7.54121C5.52291 7.5691 5.57268 7.60788 5.61338 7.65527L6.94023 9.12949L10.5317 4.85479C10.6123 4.76164 10.7263 4.70395 10.849 4.69416C10.9718 4.68438 11.0935 4.7233 11.1878 4.80251C11.2821 4.88172 11.3414 4.99485 11.353 5.11745C11.3645 5.24006 11.3273 5.36229 11.2495 5.45771Z'
                            fill='#53C0F2'
                          />
                        </svg>
                      </Icon>
                      <CaptionText left color={colors.neutral0}>
                        Unica Pay (Virtual) - {hub?.details?.unicaPay?.name}:
                        Crypto Card
                      </CaptionText>
                    </Flexed>
                  </Flexed>
                </>
              )}

              <Flexed center between gap='10px' mb='12' key={index}>
                <Flexed center gap='5px'>
                  <Icon color={colors.lightGreen}>
                    <svg
                      width='16'
                      height='15'
                      viewBox='0 0 16 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'>
                      <path
                        d='M8.07812 1.40625C4.71807 1.40625 1.98438 4.13994 1.98438 7.5C1.98438 10.8601 4.71807 13.5937 8.07812 13.5937C11.4382 13.5937 14.1719 10.8601 14.1719 7.5C14.1719 4.13994 11.4382 1.40625 8.07812 1.40625ZM11.2495 5.45771L7.31201 10.1452C7.26882 10.1967 7.21508 10.2382 7.15442 10.2671C7.09376 10.2959 7.02761 10.3114 6.96045 10.3125H6.95254C6.88684 10.3125 6.82187 10.2986 6.76186 10.2719C6.70185 10.2451 6.64814 10.2061 6.6042 10.1572L4.9167 8.28223C4.87384 8.23677 4.8405 8.18321 4.81864 8.12468C4.79678 8.06616 4.78684 8.00386 4.78941 7.94144C4.79197 7.87902 4.80698 7.81774 4.83356 7.7612C4.86015 7.70467 4.89776 7.65402 4.9442 7.61223C4.99064 7.57044 5.04496 7.53835 5.10398 7.51786C5.16299 7.49736 5.22551 7.48887 5.28785 7.49288C5.35019 7.49689 5.41111 7.51332 5.46701 7.54121C5.52291 7.5691 5.57268 7.60788 5.61338 7.65527L6.94023 9.12949L10.5317 4.85479C10.6123 4.76164 10.7263 4.70395 10.849 4.69416C10.9718 4.68438 11.0935 4.7233 11.1878 4.80251C11.2821 4.88172 11.3414 4.99485 11.353 5.11745C11.3645 5.24006 11.3273 5.36229 11.2495 5.45771Z'
                        fill='#53C0F2'
                      />
                    </svg>
                  </Icon>
                  {hub?.name === 'Starter' ? (
                    <CaptionText left color={colors.neutral0}>
                      U1 Academy
                    </CaptionText>
                  ) : (
                    <CaptionText left color={colors.neutral0}>
                      U1 Academy - {hub?.details?.u1Academy?.name} Access
                    </CaptionText>
                  )}
                </Flexed>
              </Flexed>
              <Flexed center between gap='10px' mb='12' key={index}>
                <Flexed center gap='5px'>
                  <Icon color={colors.lightGreen}>
                    <svg
                      width='16'
                      height='15'
                      viewBox='0 0 16 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'>
                      <path
                        d='M8.07812 1.40625C4.71807 1.40625 1.98438 4.13994 1.98438 7.5C1.98438 10.8601 4.71807 13.5937 8.07812 13.5937C11.4382 13.5937 14.1719 10.8601 14.1719 7.5C14.1719 4.13994 11.4382 1.40625 8.07812 1.40625ZM11.2495 5.45771L7.31201 10.1452C7.26882 10.1967 7.21508 10.2382 7.15442 10.2671C7.09376 10.2959 7.02761 10.3114 6.96045 10.3125H6.95254C6.88684 10.3125 6.82187 10.2986 6.76186 10.2719C6.70185 10.2451 6.64814 10.2061 6.6042 10.1572L4.9167 8.28223C4.87384 8.23677 4.8405 8.18321 4.81864 8.12468C4.79678 8.06616 4.78684 8.00386 4.78941 7.94144C4.79197 7.87902 4.80698 7.81774 4.83356 7.7612C4.86015 7.70467 4.89776 7.65402 4.9442 7.61223C4.99064 7.57044 5.04496 7.53835 5.10398 7.51786C5.16299 7.49736 5.22551 7.48887 5.28785 7.49288C5.35019 7.49689 5.41111 7.51332 5.46701 7.54121C5.52291 7.5691 5.57268 7.60788 5.61338 7.65527L6.94023 9.12949L10.5317 4.85479C10.6123 4.76164 10.7263 4.70395 10.849 4.69416C10.9718 4.68438 11.0935 4.7233 11.1878 4.80251C11.2821 4.88172 11.3414 4.99485 11.353 5.11745C11.3645 5.24006 11.3273 5.36229 11.2495 5.45771Z'
                        fill='#53C0F2'
                      />
                    </svg>
                  </Icon>
                  {hub?.name === 'Elite' ? (
                    <Flexed>
                      <Flexed column>
                        <CaptionText left color={colors.neutral0}>
                          Futura Mining Hardware -
                        </CaptionText>
                        <CaptionText left color={colors.neutral0}>
                          UNLIMITED
                        </CaptionText>
                      </Flexed>
                    </Flexed>
                  ) : (
                    <Flexed column>
                      <CaptionText left color={colors.neutral0}>
                        Futura Mining Hardware -
                      </CaptionText>
                      <CaptionText left color={colors.neutral0}>
                        Max Fractions - {returnFractions(hub?.id)}
                      </CaptionText>

                      <CaptionText left color={colors.neutral0}>
                        (Up To{' '}
                        {formatUSDNoDecimals(hub?.details?.futuraMining?.limit)}
                        ) USDT/USDC
                      </CaptionText>
                    </Flexed>
                  )}
                </Flexed>
              </Flexed>
            </div>
          </Flexed>
        </div>

        <SectionSeparator margin='8px 0' style={{ background: '#fff' }} />
        <Flexed center between gap='10px' mb='8'>
          <P3 left color={colors.primary900} bold>
            Pack Price:
          </P3>
          <Flexed between alignEnd gap='2px'>
            <P3 left color={colors.neutral0} bold>
              {formatUSDNoDecimals(hub?.price)}
            </P3>
            <CaptionText color={colors.neutral0}>USDT/USDC</CaptionText>
          </Flexed>
        </Flexed>
        <Flexed center between gap='10px' mb='8'>
          <P3 left color={colors.neutral0} bold>
            BV:
          </P3>
          <P3 left color={colors.neutral0} bold>
            {formatUSDNoDecimals(hub?.details?.bv)}
          </P3>
        </Flexed>
        <Button
          mt='15'
          w='100%'
          wSM='100%'
          onClick={() => handleSelectPackage(hub)}>
          Get {hub?.name}
        </Button>
      </GridItem>
    );
  };

  const pagination = {
    clickable: true
  };

  return (
    <AnimatedDashboard zoom dark key={'marketplace'}>
      <H3 center color={colors.neutral900} mb='22'>
        Choose your U1 membership plan
      </H3>
      <Desktop>
        <EntryPackagesGrid hubs={hubs?.length}>
          {hubs?.map((hub, index) => (
            <PackageItem key={index} hub={hub} index={index} />
          ))}
        </EntryPackagesGrid>
      </Desktop>
      <Mobile>
        <SlideWrapper>
          <Swiper
            initialSlide={2}
            slidesPerView={1.2}
            centeredSlides={true}
            modules={[Pagination]}
            spaceBetween={10}
            pagination={pagination}>
            {hubs?.map((hub, index) => (
              <SwiperSlide key={index}>
                <PackageItem hub={hub} index={index} />
              </SwiperSlide>
            ))}
          </Swiper>
        </SlideWrapper>
      </Mobile>
      <Link to={DASHBOARD}>
        <P1 right centerSM color={colors.primary900} mb='22' mt='20'>
          Continue without selecting a package
        </P1>
      </Link>

      <PurchasePackageAndCombo
        selectedPackage={selectedHub}
        modal={modal}
        setModal={setModal}
        setStep={setStep}
        step={step}
        selectedLicence={selectedLicence}
        setSelectedLicence={setSelectedLicence}
      />
    </AnimatedDashboard>
  );
};
